let home = 'https://print.synchro-bus.fr/';
let urlApi = home + 'wp-json/';

export default {
    api: urlApi,
    home
};
